<script lang="ts">
	import type { ComponentProps } from 'svelte';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';

	interface Props {
		title: string;
		clamp?: string;
		badge?: ComponentProps<typeof Badge>;
	}

	const { title, clamp, badge }: Props = $props();
</script>

{#if title}
	<div class="inline-flex justify-between w-full min-w-0 text-body text-md font-600 gap-x-0.5 text-coloredneutral">
		<span data-testid="card-title" class={['pb-0.5', clamp ?? 'clamp-lines-2']}>{title}</span>
		{#if badge}
			<Badge {...badge} />
		{/if}
	</div>
{/if}
